module.exports = __webpack_public_path__ + "static/media/Folder.b4153c3a.svg";